import { Box, Button, Typography, Link } from "@mui/material";
import React, { useState, useEffect } from "react";
import "./CookieNotice.css";

const CookieNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has already seen the notice
    const hasSeenCookieNotice = localStorage.getItem("cookieNoticeSeen");

    if (!hasSeenCookieNotice) {
      // Show it after a short delay to not interrupt initial page load
      setTimeout(() => setVisible(true), 1500);
    }
  }, []);

  const dismissNotice = () => {
    setVisible(false);
    localStorage.setItem("cookieNoticeSeen", "true");
  };

  if (!visible) return null;

  return (
    <Box className="cookie-notice">
      <Typography variant="body2">
        Diese Website verwendet nur technisch notwendige Cookies für die Authentifizierung. Diese
        sind für die Funktion der Website erforderlich.
        <Link href="/datenschutz" sx={{ ml: 0.5 }}>
          {" "}
          Mehr erfahren
        </Link>
      </Typography>
      <Button
        onClick={dismissNotice}
        variant="contained"
        color="primary"
        size="small"
        sx={{ whiteSpace: "nowrap", ml: 2 }}
      >
        Verstanden
      </Button>
    </Box>
  );
};

export default CookieNotice;
